'use client';
import { createContext, type PropsWithChildren, useContext, useEffect, useMemo } from 'react';
import { createApp } from './createApp';
import type { GlobalAppStateStoreInstance } from './GlobalAppStateStore/selectors';
import type { AppContext } from './types';

const AppContextReactContext = createContext<AppContext | null>(null);

export function useAppContext(): AppContext {
  const v = useContext(AppContextReactContext);
  if (!v) throw new Error('useAppContext called outside AppContextProvider');
  return v;
}

export function AppContextProvider({
  gas,
  children,
}: PropsWithChildren<{ gas: GlobalAppStateStoreInstance }>) {
  const handle = useMemo(() => createApp({ gas }), [gas]);
  useEffect(() => () => handle.dispose(), [handle]);
  return (
    <AppContextReactContext.Provider value={handle.ctx}>{children}</AppContextReactContext.Provider>
  );
}
